import Table from '@/components/Table/Table.jsx'
import TableChooseProduct from '../_PRODUCT/TableChooseProduct.jsx'

const TableChooseSf = (props) => {
    const columns = [
        {
            title: '项目编号',
            dataIndex: 'prjNo',
            component: <Table.ViewText />,
        },

        {
            title: '项目名称',
            dataIndex: 'prjName',
            component: <Table.ViewText />,
        },

        {
            title: '功能代码',
            dataIndex: 'sfNo',
            component: <Table.ViewText />,
        },

        {
            title: '功能名称',
            dataIndex: 'sfName',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseProduct
            columns={columns}
            {...props}
        />
    )
}

export default TableChooseSf
